import { useToast } from '@chakra-ui/react';
import { ToastPosition, useStatusToast } from '@this+that/ui';

import { getCurrentClerkUserId } from '../utils/getCurrentClerkUserId';

export const useCustomToast = () => {
  const toast = useToast();
  const isSignedIn = getCurrentClerkUserId() !== null;

  return useStatusToast(toast, {
    defaultPosition: isSignedIn
      ? ToastPosition.BottomLeft
      : ToastPosition.Bottom,
  });
};
